//Handlebars helper to output a json object as a string.
const json = (object) => JSON.stringify(object, undefined, 2);

module.exports = json;


// WEBPACK FOOTER //
// ./shared/templates/helpers/json.helper.js